import store from '@/vuex'

import NavigationLayout 	from '@/app/layouts/NavigationLayout'
import CalendarViewCtrl 	from '@/app/fragments/CalendarViewCtrl'
import HoursViewCtrl 		from '@/app/fragments/HoursViewCtrl'
import LeaveViewCtrl 		from '@/app/fragments/LeaveViewCtrl'
import ContactsViewCtrl 	from '@/app/fragments/ContactsViewCtrl'
import MoveViewCtrl 		from '@/app/fragments/MoveViewCtrl'
import NewsViewCtrl 		from '@/app/fragments/NewsViewCtrl'
import LoginFragment 		from '@/app/fragments/LoginFragment'

import TestFragment 		from '@/app/fragments/TestFragment'

function auth({next, router}) {
	console.log('auth', store);

	const didAuth = (token) => {
		const msg = {
			call: 'login',
			token: token
		};

		if (window.webkit != undefined) {
			if (window.webkit.messageHandlers.appInterface != undefined) {
				window.webkit.messageHandlers.appInterface.postMessage(msg);
			}
		}
		if (window.appInterface != undefined) {
			window.appInterface.postMessage(msg);
		}
	};

	// Has auth
	if (store.getters.auth) {
		console.log('reading auth...');

		// Test perms
		//window.location = 'moovr:' + store.getters.auth;

		//didAuth(store.getters.auth);

		return next();
	}	

	// Auth in perm storage?
	var auth = localStorage.getItem('auth');

	if (auth) {
		store.commit('auth', auth);

		store.axios.get('/me/').then(function (r) {
			console.log(r.data);
			store.commit('user', r.data);
		});

		store.axios.get('/me/stamps/active/').then(function (r) {
			console.log(r.data);
			store.commit('stamps', r.data);
		});

		// Test perms
		//window.location = 'moovr:' + store.getters.auth;

		//didAuth(store.getters.auth);

		console.log('found in persistent');
		return next();
	} else {
		console.log('not found in persistent');
	}

	return router.push({
		name: 'login'
	});
}

var meta = {
	middleware: auth
};

export default [
	{
		path: '/',
		component: NavigationLayout,
		redirect: {
			name: 'calendar'
		},
		children: [
			{ 
				name: 'calendar',
				path: '/calendar', 
				component: CalendarViewCtrl,
				meta: meta 
			},
			{ 
				name: 'leave',
				path: '/leave', 
				component: LeaveViewCtrl,
				meta: meta 
			},
			{ 
				name: 'hours',
				path: '/hours', 
				component: HoursViewCtrl,
				meta: meta 
			},
			{ 
				name: 'contacts',
				path: '/contacts', 
				component: ContactsViewCtrl,
				meta: meta 
			},
			{ 
				name: 'news',
				path: '/news', 
				component: NewsViewCtrl,
				meta: meta 
			},
			{ 
				name: 'move',
				path: '/tasks/move/:id', 
				component: MoveViewCtrl,
				meta: meta
			}
		]
	},
	{
		path: '/login',
		name: 'login',
		component: LoginFragment
	},
	{
		path: '/test',
		name: 'test',
		component: TestFragment
	}
];